var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 4.16602C10.75 3.7518 10.4142 3.41602 10 3.41602C9.58579 3.41602 9.25 3.7518 9.25 4.16602V9.24927H4.16797C3.75376 9.24927 3.41797 9.58505 3.41797 9.99927C3.41797 10.4135 3.75376 10.7493 4.16797 10.7493H9.25V15.8327C9.25 16.2469 9.58579 16.5827 10 16.5827C10.4142 16.5827 10.75 16.2469 10.75 15.8327V10.7493H15.8346C16.2489 10.7493 16.5846 10.4135 16.5846 9.99927C16.5846 9.58505 16.2489 9.24927 15.8346 9.24927H10.75V4.16602Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.052113d004a48ac8d4d777d038540164.svg";
export { ForwardRef as ReactComponent };